import React, { FC } from 'react';
import styles from './index.module.scss';
import { useActiveInboxEmail } from 'src/models/callOffs/hooks';
import { Letter } from 'react-letter';
import PreviewAttachments from 'src/pages/CallOffsPage/CallOffPreview/Attachments';

interface IProps {}

export const PreviewEmail: FC<IProps> = () => {
  const { data: callOff } = useActiveInboxEmail();
  const attachments = callOff?.attachments;

  return (
    <>
      {!!callOff && (
        <div className={styles.container}>
          <Letter className={styles.letter} html={callOff.htmlContent || callOff.content || '—'} />
        </div>
      )}
      {!!attachments && attachments.length > 0 && <PreviewAttachments />}
    </>
  );
};

export default PreviewEmail;
